import { useQuery } from '@tanstack/react-query';

import { getActiveCampaignSyncHealth } from '../api/syncHealth';
import type { ActiveCampaignSyncHealthResponse } from '../types';

export function useActiveCampaignSyncHealth(
  orgId: number | string | undefined
) {
  return useQuery<ActiveCampaignSyncHealthResponse>({
    queryKey: ['activeCampaignSyncHealth', orgId],
    queryFn: () => {
      // Explicit check so a valid numeric `0` org id isn't treated as missing.
      if (orgId === undefined || orgId === '') {
        throw new Error('orgId is required');
      }
      return getActiveCampaignSyncHealth(orgId);
    },
    enabled: orgId !== undefined && orgId !== '',
    refetchInterval: query => (query.state.data?.connected ? 30000 : false),
  });
}
